<app-dialog [config]="data.config" (actionButtonClicked)="onFormSubmit($event)">
    <ng-container dialog-title>Upload Execution</ng-container>

    <ng-container
        *ngIf="orderForm && orderForm.form"
        dialog-process-in-progress
    >
        <div class="container">
            <form [formGroup]="orderForm.form">
                <div [ngClass]="{'mb-3': orderForm.controls.product.errors.length > 0}">
                    <app-select
                        [formControlName]="orderForm.controls.product.name"
                        [control]="orderForm.controls.product"
                    ></app-select>
                </div>
                <div *ngIf="productPriceBoxWarningText" class="row order-details-wrapper">
                    <div class="col-lg-10 col-md col">
                        <div class="card">
                            <div class="card-body">
                                <span class="label product-price-warning">{{productPriceBoxWarningText}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    [ngClass]="{
                        'mb-3': orderForm.controls.orderType.errors.length > 0
                    }"
                    class="order-amount-input"
                >
                    <div class="row">
                        <span class="col pt-3">Execution Type</span>
                        <div class="col">
                            <app-radio-group
                                [control]="orderForm.controls.orderType"
                                [formControlName]="orderForm.controls.orderType.name"
                            ></app-radio-group>
                        </div>
                    </div>
                </div>

                <div *ngIf="this.model.product">

                <div
                    [ngClass]="{
                        'mb-3': orderForm.controls.amount.errors.length > 0,
                        'text-success': orderForm.controls.amount.value > 0,
                        'text-danger': orderForm.controls.amount.value < 0
                    }"
                    class="order-amount-input"
                >
                    <div class="app-input fill">
                        <app-amount-input
                            [onlyIntegers]="!isMutualFundAccount"
                            [control]="orderForm.controls.amount"
                            [formControlName]="orderForm.controls.amount.name"
                        ></app-amount-input>
                    </div>
                </div>
                <div
                    [ngClass]="{
                        'mb-3': orderForm.controls.price.errors.length > 0,
                        'text-success': orderForm.controls.price.value > 0,
                        'text-danger': orderForm.controls.price.value < 0
                    }"
                    class="order-amount-input"
                >
                    <div class="app-input fill">
                        <app-amount-input
                            [control]="orderForm.controls.price"
                            [formControlName]="orderForm.controls.price.name"
                        ></app-amount-input>
                    </div>
                </div>
                <div
                    [ngClass]="{
                        'mb-3': orderForm.controls.interest.errors.length > 0,
                        'text-success': orderForm.controls.interest.value > 0,
                        'text-danger': orderForm.controls.interest.value < 0
                    }"
                    class="order-amount-input"
                >
                    <div class="app-input fill">
                        <app-panel-input
                            [control]="orderForm.controls.interest"
                            [formControlName]="orderForm.controls.interest.name"
                        ></app-panel-input>
                    </div>
                </div>

                <div *ngIf="model.totals" class="row order-details-wrapper">
                    <div *ngIf="model.totals.quantity" class="col-lg-6 col-md col">
                        <div class="card">
                            <div class="card-body">
                                <span class="label product-price-desc">Quantity</span>
                                <span class="value">{{ model.totals.quantity | formatDecimal }}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="model.totals.amount" class="col-lg-6 col-md col">
                        <div class="card">
                            <div class="card-body">
                                <span class="label product-price-desc">Amount</span>
                                <span class="value">{{ model.totals.amount | formatDecimal }}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="model.totals.fee" class="col-lg-6 col-md col">
                        <div class="card">
                            <div class="card-body">
                                <span class="label product-price-desc">Fee</span>
                                <span class="value">{{ model.totals.fee | formatDecimal }}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="model.totals.interest" class="col-lg-6 col-md col">
                        <div class="card">
                            <div class="card-body">
                                <span class="label product-price-desc">Interest</span>
                                <span class="value">{{ model.totals.interest | formatDecimal }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    [ngClass]="{
                        'mb-3': orderForm.controls.executionCreatedOnDate.errors.length > 0
                    }"
                    class="order-amount-input"
                >
                    <div class="app-input fill">
                        <app-datepicker
                            [control]="orderForm.controls.executionCreatedOnDate"
                            [formControlName]="orderForm.controls.executionCreatedOnDate.name"
                        ></app-datepicker>
                    </div>
                </div>
                <div
                    [ngClass]="{
                        'mb-3': orderForm.controls.executionCreatedOn.errors.length > 0
                    }"
                    class="order-amount-input"
                >
                    <div class="app-input fill">
                        <app-panel-input
                            [control]="orderForm.controls.executionCreatedOn"
                            [formControlName]="orderForm.controls.executionCreatedOn.name"
                        ></app-panel-input>
                    </div>
                    <small class="text-danger">(format: 13:17:21)</small>
                </div>
                <div
                    [ngClass]="{
                        'mb-3': orderForm.controls.counterparty.errors.length > 0
                    }"
                    class="order-amount-input"
                >
                    <div class="app-input fill">
                        <app-select
                            [control]="orderForm.controls.counterparty"
                            [formControlName]="orderForm.controls.counterparty.name"
                        ></app-select>
                    </div>
                </div>
                <div *ngIf="model.product?.buyPrice" class="row order-details-wrapper">
                    <div class="col-md-12 col">
                        <div *ngIf="model.totals.insufficient" class="text-danger">
                            Insufficient resources
                        </div>
                        <div *ngIf="model.totals.warning && isBonds && isBuy" class="text-danger">
                            The value must be a multiple of {{model.product.nominalValue | formatDecimal:model.product.currency }}
                        </div>
                        <div *ngIf="model.totals.warning && isBonds && isSell" class="text-danger">
                            Order value cannot be less than {{model.product.minimumBuyOrderSize | formatDecimal:model.product.currency }}
                        </div>
                        <div *ngIf="model.totals.warning && isMutualFunds && isBuy" class="text-danger">
                            Minimum order amount:  {{model.product.minimumBuyOrderSize | formatDecimal:model.product.currency }}
                        </div>
                    </div>
                </div>

                </div>
            </form>
        </div>
    </ng-container>
</app-dialog>
